import { ErrorBoundary, TrackingProps } from '@taxbit-private/cosmic'

import logError from 'vendors/logError'

type Props = {
  children: React.ReactNode
} & TrackingProps

/**
 * The Cosmic error boundary needs access to the Cosmic theme to display error UI properly,
 * and then renders application content. Historically this component also swapped themes for
 * legacy Material UI; that handling is intentionally removed as we migrate away from MUI.
 */
const CosmicErrorBoundary: React.FC<Props> = ({ children, trackingId }) => {
  return (
    <ErrorBoundary trackingId={trackingId} logError={logError}>
      {children}
    </ErrorBoundary>
  )
}

export default CosmicErrorBoundary
